import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75f0ebc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-page" }

import {onMounted, onUnmounted, onUpdated, reactive, ref} from "vue";
import {LeftOutlined, RightOutlined} from "@ant-design/icons-vue";
import emit from "@/lib/emit";


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollPagerView',
  setup(__props) {

const scrollContent = ref()
const info = reactive({
  filter: {sort: {value: '推荐排序', items: ['推荐排序', '最新上架', '使用最多']}},
  festivalScroll: {offset: 0, left: false, right: true}
})

onMounted(() => {
  scrollButtonRefresh(scrollContent.value as HTMLDivElement)
  emit.on('window.resize', () => scrollButtonRefresh(scrollContent.value as HTMLDivElement))
})
onUnmounted(() => emit.off('window.resize'))
onUpdated(() => scrollButtonRefresh(scrollContent.value as HTMLDivElement))

const onScroll = (e: Event) => scrollButtonRefresh(e.target as HTMLDivElement)

const scrollButtonRefresh = (el: HTMLDivElement) => {
  // console.log(el.scrollWidth, el.clientWidth, el.offsetWidth, el.scrollLeft)
  if (el.scrollWidth - el.clientWidth == 0) {
    // 一样宽，没有超出，不需要滚动
    info.festivalScroll.left = false
    info.festivalScroll.right = false
  } else if (el.scrollLeft == 0) {
    // 左边为0，只需要右侧滚动
    info.festivalScroll.left = false
    info.festivalScroll.right = true
  } else if (el.scrollWidth - el.clientWidth == el.scrollLeft) {
    // 右侧为0，只需要左侧滚动
    info.festivalScroll.left = true
    info.festivalScroll.right = false
  } else {
    // 否则，需要两侧滚动
    info.festivalScroll.left = true
    info.festivalScroll.right = true
  }
}

const goLeft = () => {
  let el = scrollContent.value as HTMLDivElement
  // console.log('goLeft 左侧剩余：', el.scrollLeft, '总宽度：', el.scrollWidth, '窗口宽度：', el.clientWidth)
  // 左侧剩余 > 窗口宽度
  if (el.scrollLeft > el.clientWidth) el.scrollTo({left: el.scrollLeft - el.clientWidth, behavior: 'smooth'})
  else el.scrollTo({left: 0, behavior: 'smooth'})
}

const goRight = () => {
  let el = scrollContent.value as HTMLDivElement

  // console.log('goRight 滚动偏移：', el.scrollLeft, '右侧剩余：', el.scrollWidth - el.clientWidth - el.scrollLeft, '总宽度：', el.scrollWidth, '窗口宽度：', el.clientWidth, (el.scrollWidth - el.clientWidth - el.scrollLeft) < el.clientWidth)
  // 右侧剩余 < 窗口宽度 直接滚动到底
  if ((el.scrollWidth - el.clientWidth - el.scrollLeft) > el.clientWidth)
    el.scrollTo({left: el.scrollLeft + el.clientWidth, behavior: 'smooth'})
  else el.scrollTo({left: el.scrollWidth - el.clientWidth, behavior: 'smooth'})
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "slick left",
      onClick: goLeft
    }, [
      _renderSlot(_ctx.$slots, "left", {}, () => [
        _createVNode(_unref(LeftOutlined))
      ])
    ], 512), [
      [_vShow, info.festivalScroll.left]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "slick right",
      onClick: goRight
    }, [
      _renderSlot(_ctx.$slots, "right", {}, () => [
        _createVNode(_unref(RightOutlined))
      ])
    ], 512), [
      [_vShow, info.festivalScroll.right]
    ]),
    _createElementVNode("div", {
      class: "scroll-content",
      ref_key: "scrollContent",
      ref: scrollContent,
      onScroll: onScroll
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 544)
  ]))
}
}

})